export function toFloat(num: number, fraction: number = 2) {
  return (Math.round(num * 10 ** fraction) / 10 ** fraction).toFixed(fraction);
}

export function numberWithCommas(value: number) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
